import request from '@/utils/seftRequest';

// 校验能过户
export function subsTransferCheckBsnl(data) {
  return request('/ding/subsService/subsTransferCheckBsnl', {
    method: 'POST',
    body: data,
  });
}

// 过户提交
export function subsTransferBsnl(data) {
  return request('/ding/subsService/subsTransferBsnl', {
    method: 'POST',
    body: data,
  });
}

// 移机可选套餐查询
export function qryOfferForShifting(data) {
  return request('/ding/custService/qryOfferForShifting', {
    method: 'POST',
    body: data,
  });
}
